import { connect } from 'react-redux';
var mapStateToProps = function () { return ({}); };
var mapDispatchToProps = function (dispatch) { };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DollarPriceInput.container.js.map